import {
  GET_TIMESHEETSECURITY_REQUEST,
  GET_TIMESHEETSECURITY_SUCCESS
} from "../Constants";
  
  export default (state = {}, action) => {
    switch (action.type) {
      case GET_TIMESHEETSECURITY_REQUEST:
        return {
          ...state,
          isFetching: action.isFetching
        };
      case GET_TIMESHEETSECURITY_SUCCESS:
        return {
          ...state,
          isFetching: action.isFetching,
          securityList: action.securityList
        };
      default:
        return state;
    }
  };
  